import { InputAdornment, makeStyles } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import ApartmentIcon from "@material-ui/icons/Apartment"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { signOut } from "src/redux/slices/authSlice"
import {
  getComplex,
  getRemoteUnits,
  getRemoteUsers,
  selectGarita,
  selectSelectedComplexId,
  setSelectedComplexId,
} from "src/redux/slices/complexSlice"
import { complexRef } from "src/services/complexServices"
import { getConjunto } from "src/views/usuarios/services/firestore"

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    flex: "0 1 280px",
    maxWidth: 280,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    "& .MuiInputBase-root": {
      fontSize: 14,
    },
  },
}))

const ConjuntosSelect = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const user = useSelector(state => state.auth.user)
  const selectedComplexId = useSelector(selectSelectedComplexId)
  const [selectedConjunto, setSelectedConjunto] = useState(null)
  const [complexs, setComplexs] = useState([])
  const [loading, setLoading] = useState(false)

  const handleComplexChange = conjunto => {
    if (!conjunto) return
    dispatch(getComplex(conjunto.uid))
    dispatch(getRemoteUsers(conjunto.uid))
    dispatch(getRemoteUnits(conjunto.uid))
    dispatch(setSelectedComplexId(conjunto.uid))
    dispatch(selectGarita(null))
    setSelectedConjunto(conjunto)
  }

  useEffect(() => {
    let isMounted = true
    const fetchComplexes = async () => {
      try {
        setLoading(true)
        dispatch(selectGarita(null))
        const conjuntosId = user.complexs || []
        const activeComplexPromises = []
        if (conjuntosId.length > 0) {
          activeComplexPromises.push(
            ...conjuntosId.map(async conjunto => {
              const complex = complexRef(conjunto.uid)
              const doc = await complex.get()
              if (doc.exists && doc.data().isActive !== false) {
                return {
                  ...conjunto,
                  nombre: doc.data().Nombre,
                  Imagen: doc.data().Imagen,
                }
              }
              return null
            })
          )
        } else if (user.ConjuntoUidResidencia) {
          activeComplexPromises.push(
            getConjunto(user.ConjuntoUidResidencia).then(doc => {
              const conjunto = doc.data()
              if (doc.exists && conjunto.isActive !== false) {
                return {
                  uid: conjunto.id,
                  nombre: conjunto.Nombre,
                  Imagen: conjunto.Imagen,
                }
              }
              return null
            })
          )
        }
        const results = await Promise.all(activeComplexPromises)
        const conjuntosActivos = results.filter(result => result !== null)
        setComplexs(conjuntosActivos)
        setLoading(false)
        if (!isMounted) return
        if (conjuntosActivos.length === 0) {
          enqueueSnackbar("No se encontraron conjuntos habilitados.", {
            variant: "error",
          })
          dispatch(signOut())
          return
        }
        const complexSelected =
          conjuntosActivos.find(
            conjunto => conjunto.uid === selectedComplexId
          ) || conjuntosActivos[0]
        if (complexSelected.uid !== selectedComplexId) {
          handleComplexChange(complexSelected)
        } else {
          setSelectedConjunto(complexSelected)
        }
      } catch (error) {
        enqueueSnackbar("Error al cargar los conjuntos.", {
          variant: "error",
        })
      }
    }

    fetchComplexes()
    return () => {
      isMounted = false
    }
  }, [user.complexs])

  return (
    complexs && (
      <div className={classes.root}>
        {complexs.length > 1 ? (
          <Autocomplete
            fullWidth
            loading={loading}
            options={complexs}
            getOptionLabel={option => option.nombre}
            noOptionsText="No se han encontrado conjuntos"
            value={selectedConjunto}
            onChange={(event, newValue) => {
              handleComplexChange(newValue)
            }}
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <ApartmentIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        ) : (
          <TextField
            fullWidth
            size="small"
            contentEditable={false}
            InputLabelProps={{ shrink: true }}
            variant="standard"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ApartmentIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            color="primary"
            component="span"
            value={selectedConjunto?.nombre}
          />
        )}
      </div>
    )
  )
}

export default ConjuntosSelect
